<template>
    <div :class="position" class="bg-white intro-slider__inner flex flex-col">
        <div
        class="intro-slider__content"
        :class="{ 'flex-grow': position !== 'pos-3' }"
    >
        <div class="intro-slider__img">
            <Cause v-if="img === 'cause'" />
            <Beneficiary v-else-if="img === 'beneficiary'" />
            <ChangeMaker v-else-if="img === 'intro-hero'" />
            <Thankyou v-else-if="img === 'thanku-slider'" />
        </div>
        <div class="intro-slider__header">
            <h2 class="intro-slider__head color-text text-center font-bold">
                {{ headTop }}
            </h2>
        </div>
        <p class="intro-slider__desc page-subtitle text-12 text-light_grey text-center">
            {{ description }}
        </p>
    </div>       
       
       <template v-if="img === 'thanku-slider'">
            <Button
                type="sub-link"
                route="/login"
                :text="$t('Start Giving!')"
                classes="mx-auto py-6 px-4 start-app-btn w-full btn-custom" 
                @click.native="redirectToSignUp"
            ></Button>
        </template>
    </div>
</template>

<script>
import Button from "../UI/Button";
import SvgIcon from "../UI/SvgIcon";
import Cause from "../Icons/Cause";
import Beneficiary from "../Icons/Beneficiary";
import Thankyou from "../Icons/Thankyou";
import ChangeMaker from "../Icons/ChangeMaker";

export default {
    name: "IntroSlide",

    components: {
        Beneficiary,
        Cause,
        SvgIcon,
        Button,
        Thankyou,
        ChangeMaker
    },

    mounted() {
        localStorage.setItem('signup',true);
    },

    props: [
        "position",
        "headTop",
        "headBottom",
        "img",
        "description",
        "width",
        "height"
    ],

    data: function() {
        return {};
    },

    methods: {
        redirectToSignUp: function(){
            localStorage.setItem('signup',true);
        }
    }
};
</script>
